import { DismissIcon } from "../../materials/icons/dismiss-icon/DismissIcon";
import { Body } from "../body/Body";
import { Ellipsis } from "../ellipsis/Ellipsis";
import {
  Button,
  DismissWrapper,
  IconWrapper,
  Props,
  Wrapper,
  text,
} from "./Selection.Parts";

export const Selection = ({
  ref,
  icon,
  $size = "medium",
  value,
  active,
  passive,
  disabled,
  invalid = false,
  focusable = false,
  unclearable = false,
  dismissReady = true,
  $variant = "default",
  onClick,
  onDismiss,
}: Props) => {
  const shouldShowDismissHandlers =
    !passive && !disabled && !dismissReady && onDismiss;

  //#region Handlers
  const handleDismiss = (e: React.MouseEvent | React.KeyboardEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onDismiss?.();
  };

  const handleMainClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (dismissReady && onDismiss) {
      onDismiss();
    } else {
      onClick?.(e);
    }
  };
  //#endregion

  if (passive)
    return (
      <Wrapper $size={$size}>
        {icon && <IconWrapper aria-hidden>{icon}</IconWrapper>}
        <Ellipsis>
          <Body variant="normal-strong">{value}</Body>
        </Ellipsis>
      </Wrapper>
    );

  return (
    <Button
      ref={ref}
      type="button"
      $size={$size}
      $active={active}
      $invalid={invalid}
      $variant={$variant}
      $dismissible={!unclearable}
      disabled={disabled}
      $dismissReady={dismissReady}
      tabIndex={focusable ? 0 : -1}
      aria-invalid={invalid || undefined}
      onClick={handleMainClick}
    >
      {icon && <IconWrapper aria-hidden>{icon}</IconWrapper>}
      <Ellipsis>
        <Body color={disabled ? "shade700" : undefined} variant="normal-strong">
          {value}
        </Body>
      </Ellipsis>
      {!unclearable && (
        <DismissWrapper
          role={shouldShowDismissHandlers ? "button" : undefined}
          aria-label={
            shouldShowDismissHandlers ? text.dismissAriaLabel : undefined
          }
          aria-hidden={!shouldShowDismissHandlers ? true : undefined}
          tabIndex={shouldShowDismissHandlers ? 0 : -1}
          onClick={shouldShowDismissHandlers ? handleDismiss : undefined}
          onKeyDown={
            shouldShowDismissHandlers
              ? (e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    handleDismiss(e);
                  }
                }
              : undefined
          }
        >
          <DismissIcon small aria-hidden />
        </DismissWrapper>
      )}
    </Button>
  );
};
